import React from 'react';
import PropTypes from 'prop-types';

import StatusBadge from '../../../../../components/StatusBadge';
import { ReportsPageDuskIds } from '../../../../../constants/duskIds';

const RequirementStatusCell = ({ value: overallStatus, row: { original } }) => (
  <StatusBadge
    duskSelector={ReportsPageDuskIds.getInsuredStatusById(original.insuredId)}
    minW="105px"
    size="sm"
    status={overallStatus}
  />
);

RequirementStatusCell.propTypes = { value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]) };

export default RequirementStatusCell;
